/* eslint-disable import/no-unresolved */

import React from "react";
import me from "models/me";
import { getStore } from "store";
import App from "lib/app";
import { SnackbarAddPayload, add as snackbarAdd } from "actions/snackbars";
import { loadRemote } from "@module-federation/enhanced/runtime";
import { Spinner } from "@nuorder/components";

const HostWrapper = React.lazy(async () => {
    return await loadRemote("Payments/HostWrapper");
});

// This is an HOF that's going to inject dependencies that we need as props into a given component.
// These will be consumed on the module federation side. This will make so that we can have login information
// or context information shared between the host and the MFE components.

const injectModules = (Component, props: any = {}) => {
    const store = getStore();
    const hostOnSnackbarAdd = (params: SnackbarAddPayload) => {
        store.dispatch(snackbarAdd(params));
    };
    const { router, ...clearedProps } = props;
    //deleting or setting to undefined the router prop will throw an error as it is readonly
    const partialRouter = {
        push: router?.push,
        params: router?.params,
        location: router?.location,
    };

    return (
        <React.Suspense fallback={<Spinner />}>
            <HostWrapper
                hostMe={me}
                hostStore={store}
                hostApp={App}
                hostOnSnackbarAdd={hostOnSnackbarAdd}
                hostRouter={partialRouter}
            >
                <Component {...clearedProps} />
            </HostWrapper>
        </React.Suspense>
    );
};

export default injectModules;
